import videojs from 'video.js';
import './button.js';
import './modal.js';

class PromoCode extends videojs.getPlugin('plugin') {
  constructor(player, options) {
    super(player, options);
    player.on('ready', () => {
      player.addClass('vjs-promo-code');
      setTimeout(() => {
        let buttonGroupComponent = player.getChild('ButtonGroupComponent');
        if (buttonGroupComponent) {
          buttonGroupComponent.addChild('PromoCodeButton', options);
          player.addChild('PromoCodeModal', options);
        }
      });
    });
  }
}

videojs.registerPlugin('promoCode', PromoCode);

